import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { PartnerAttachmentAddDto, PartnerDashboardDto, PartnerMainDataAddEditDto, PartnerMainDataDto, PartnerSelectListWithPermissionsDto, SearchPartnerDto } from '../models/partner-models';
import { SelectList } from '../../../shared/models/select-list';


@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  baseUrl = 'Partner';
  constructor(private httpCommonService: HttpCommonService) {
  }

  search(searchObjVM?: SearchPartnerDto): Observable<ApiResponse<SearchPartnerDto>> {
    return this.httpCommonService.post<ApiResponse<SearchPartnerDto>>({
      url: this.baseUrl + "/Search",
      body: searchObjVM
    });
  }

  getPartnerDashboard(): Observable<PartnerDashboardDto> {
    return this.httpCommonService.get({ url: this.baseUrl + "/GetPartnerDashboard" });
  }

  export(searchObjVM: SearchPartnerDto): Observable<Blob> {
    return this.httpCommonService.post({ url: this.baseUrl + "/Export", body: searchObjVM, responseType: 'blob' });
  }

  saveMainData(obj: PartnerMainDataAddEditDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/SaveMainData', body: obj });
  }


  getSelectList(): Observable<ApiResponse<SelectList[]>> {
    return this.httpCommonService.get<ApiResponse<SelectList[]>>({
      url: this.baseUrl + "/GetSelectList"
    });
  }

  getSelectListWithPermissions(): Observable<ApiResponse<PartnerSelectListWithPermissionsDto[]>> {
    return this.httpCommonService.get<ApiResponse<PartnerSelectListWithPermissionsDto[]>>({
      url: this.baseUrl + "/GetSelectListWithPermissions"
    });
  }

  delete(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.delete<ApiResponse<string>>
      ({ url: this.baseUrl + '/Delete/'+id });
  }

  getById(id: string): Observable<ApiResponse<PartnerMainDataDto>> {
    return this.httpCommonService
      .get<ApiResponse<PartnerMainDataDto>>({ url: this.baseUrl + '/Get/' + id });
  }

  checkLicenseNumberUnique(licenseNumber: string, partnerId?: string): Observable<ApiResponse<boolean>> {
    const url = partnerId ?
      `${this.baseUrl}/CheckLicenseNumberUnique/${licenseNumber}/${partnerId}` :
      `${this.baseUrl}/CheckLicenseNumberUnique/${licenseNumber}`;
    return this.httpCommonService.get<ApiResponse<boolean>>({ url });
  }

  getClassification(partnerId: string): Observable<ApiResponse<any>> {
    return this.httpCommonService.get<ApiResponse<any>>({
      url: this.baseUrl + '/GetClassification/' + partnerId
    });
  }

  saveClassification(request: any): Observable<ApiResponse<any>> {
    return this.httpCommonService.post<ApiResponse<any>>({
      url: this.baseUrl + '/SaveClassification',
      body: request
    });
  }
}
